import React, { useCallback, useEffect, useState } from "react";
import { message, Button, Empty, Avatar, Input, Modal, Tabs, Divider } from "antd";
import { UserOutlined, CheckOutlined } from "@ant-design/icons";

import EmployeeForm from "./EmployeeForm";

import { getUsers } from "../../api/user";
import { updateProject } from "../../api/project";
import { getFileUrl } from "../../api/file";

const { Search } = Input;

export default function SearchAndCreateEmployeeModal({
  isModalOpen,
  handleOk,
  handleCancel,
  project,
  afterClose,
}) {
  const [employees, setEmployees] = useState(null);
  const [formInstance, setFormInstance] = useState();
  const [searchQuery, setSearchQuery] = useState(null);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(5);

  const addUserToProject = async (user) => {
    const res = await updateProject({
      ...project,
      projectUsers: [
        {
          isActive: 1,
          user: {
            id: user.id,
          },
          project: {
            id: project.id,
          },
        },
      ],
    }).then((res) => {
      handleCancel();
      message.success("Employee added successfully");
    });
  };

  const fetchEmployees = useCallback(async ({ page, perPage, q }) => {
    try {
      const { results } = await getUsers({ page, perPage, q });
      setEmployees(results);
    } catch (err) {
      console.error(err);
      message.error("Something went wrong");
    }
  }, [perPage]);

  useEffect(() => {
    fetchEmployees({ page, perPage, q: searchQuery });
  }, [fetchEmployees, isModalOpen, page, perPage, searchQuery]);

  const items = [
    {
      key: "1",
      label: "Add Available Employee to Project",
      children: (
        <div>
          <Search placeholder="Type to search available employees..." allowClear onSearch={(value) => setSearchQuery(value)} />
          {/* List of available Employees */}
          <ul className="my-4">
            {employees && employees.length > 0 ? (
              employees.map((employee) => {
                const match = project.projectUsers.some(
                  (user) => user.user.id === employee.id && user.isActive
                );

                return (
                  <li key={employee.id}>
                    <div
                      className="flex items-center justify-between w-full py-2">
                      <div className="flex items-center">
                        <Avatar
                          icon={<UserOutlined />}
                          src={employee.avatar ? getFileUrl(employee.avatar) : null}
                          size={45}
                        />
                        <div className="ml-4">
                          <p className="text-[14px] leading-[22px] font-normal">
                            {employee.firstName + " " + employee.lastName}
                          </p>
                          <p className="text-[14px] leading-[22px] font-normal opacity-45">
                            {employee.role}
                          </p>
                        </div>
                      </div>

                      <Button
                        type="link"
                        disabled={match}
                        onClick={() => addUserToProject(employee)}
                      >
                        {!match ? (
                          "Add to Project"
                        ) : (
                          <div>
                            {" "}
                            <CheckOutlined className="text-green-500" /> Added to
                            Project
                          </div>
                        )}
                      </Button>
                    </div>
                    <Divider className="p-0 m-0" />
                  </li>
                );
              })
            ) : (
              <Empty className="my-8" />
            )}
          </ul>
        </div>
      ),
    },
    {
      key: "2",
      label: "Create New Employee",
      children: (
        <EmployeeForm
          onFormInstanceReady={(instance) => {
            setFormInstance(instance);
          }}
        />
      ),
    },
  ];

  return (
    <Modal
      title="Add Employee to Project"
      open={isModalOpen}
      onCancel={handleCancel}
      okText="Save"
      afterClose={afterClose}
      onOk={async () => {
        try {
          const values = await formInstance?.validateFields();
          formInstance?.resetFields();
          handleOk(values);
        } catch (error) {
          console.log("Failed:", error);
        }
      }}
    >
      <Tabs defaultActiveKey="1" items={items} />
    </Modal>
  );
}
